export default __webpack_public_path__ + "static/media/Avatar-6.9c5fb215.svg";